import { useEffect, useRef } from 'react';

import { changeHeaderBlurStatus } from '@/redux/reducers/appReducer';
import { useAppDispatch } from '@/redux/store';

const useBlurHeader = (
  scrollContainerRef: React.RefObject<HTMLDivElement>,
): void => {
  const startPosition = useRef<number | null>(null);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const container = scrollContainerRef.current;

    if (!container) return;

    const onTouchStart = (event: TouchEvent): void => {
      startPosition.current = event.touches[0].clientY;
    };

    const onTouchMove = (): void => {
      const scrollPosition = container.scrollTop;
      dispatch(changeHeaderBlurStatus(scrollPosition > 0));
    };

    const onScroll = (): void => {
      const scrollPosition = container.scrollTop;
      dispatch(changeHeaderBlurStatus(scrollPosition > 0));
    };

    container.addEventListener('touchstart', onTouchStart, {
      capture: true,
      passive: true,
    });
    container.addEventListener('touchmove', onTouchMove, {
      capture: true,
      passive: true,
    });
    container.addEventListener('scroll', onScroll, { passive: true });

    return (): void => {
      container.removeEventListener('touchstart', onTouchStart, {
        capture: true,
      });
      container.removeEventListener('touchmove', onTouchMove, {
        capture: true,
      });
      container.removeEventListener('scroll', onScroll);
    };
  }, []);
};

export { useBlurHeader };
